module.exports = __webpack_public_path__ + "img/avatar.416c59f1.svg";